<template>
    <tr v-if="!field.isComplexType">
        <td>{{<span>{{fieldPath}}</span>}}</td>
        <td>{{field.description}}</td>
    </tr>
    <tr v-else>
        <td colspan="2" class="guide-notification-table-expandable">
            <table class="table table-hoverable">
                <tr @click="toggleIsExpanded">
                    <td><span>{{fieldPath}}</span> <span class="text-muted">({{field.type}})</span></td>
                    <td><strong class="float-right">{{expandedSign}}</strong></td>
                </tr>
                <guide-notification-field
                    v-show="isExpanded"
                    v-for="subField in field.complex.fields"
                    :field="subField"
                    :parent="field"
                    :base-path="fieldPath"
                    :key="getFieldLocation(fieldPath, subField)"/>
            </table>
        </td>
    </tr>
</template>
<script>
    export default {
        name: 'guide-notification-field',
        props: {
            parent: {
                type: Object,
            },
            field: {
                type: Object,
            },
            basePath: {
                type: String,
            },
        },
        data() {
            return {
                isExpanded: false,
            };
        },
        computed: {
            fieldPath() {
                let {basePath} = this;
                if (this.parent.type === 'array') {
                    basePath = `${this.basePath}.i`;
                }
                return this.getFieldLocation(basePath, this.field);
            },
            expandedSign() {
                return this.isExpanded ? '-' : '+';
            },
        },
        methods: {
            getFieldLocation(route, field) {
                return `${route}.${field.name}`;
            },
            toggleIsExpanded() {
                this.isExpanded = !this.isExpanded;
            },
        },
    };
</script>
